/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Faq4a1Inputs */

const zh_pricing_faq4a1 = /** @type {(inputs: Pricing_Faq4a1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max 计划起步包含 10 个席位，可以根据需要灵活扩展，具体请联系我们的销售团队。`)
};

const en_pricing_faq4a1 = /** @type {(inputs: Pricing_Faq4a1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Max plan starts with 10 seats and can be flexibly expanded. Contact our sales team for details.`)
};

const es_pricing_faq4a1 = /** @type {(inputs: Pricing_Faq4a1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El plan Max comienza con 10 asientos y se puede ampliar de forma flexible. Contacta a nuestro equipo de ventas para más detalles.`)
};

/**
* | output |
* | --- |
* | "The Max plan starts with 10 seats and can be flexibly expanded. Contact our sales team for details." |
*
* @param {Pricing_Faq4a1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const pricing_faq4a1 = /** @type {((inputs?: Pricing_Faq4a1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Faq4a1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_pricing_faq4a1(inputs)
	if (locale === "en") return en_pricing_faq4a1(inputs)
	return es_pricing_faq4a1(inputs)
});
export { pricing_faq4a1 as "pricing_faq4A" }